(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-blog-page"]) return;
  try {
    
  
$(function () {
    $(".blog-articles__article").slice(0, 20).show();
    if ($('.tab-pane.active').find(".blog-articles__article:hidden").length == 0) {
        $(".tab-pane.active .loadMore").hide();
      }else{
        $(".tab-pane.active .loadMore").show();
      }
    $(".loadMore").on('click', function (e) {
        e.preventDefault();
        $(".tab-pane.active .blog-articles__article:hidden").slice(0, 20).slideDown();
        if ($('.tab-pane.active').find(".blog-articles__article:hidden").length == 0) {
          $(".tab-pane.active .loadMore").hide();
        }else{
          $(".tab-pane.active .loadMore").show();
        }
        // $('html,body').animate({
        //     scrollTop: $(this).offset().top -
        // }, 1500);
    });
});
    $(document).ready(function(){

      var dta =  window.location.href;
      var arr = dta.split('#');

      if(typeof arr[1] !== "undefined"){  
        $('.tab-content .tab-pane').removeClass('active');
        $('.tab-content #'+arr[1]).addClass('active');
        $('.nav-tabs li').removeClass('active');
        $('.nav-tabs li a[href="#'+arr[1]+'"]').parent().addClass('active');  
      } 
      
      $('.nav-tabs a').on('click', function (e) {
          setTimeout(function() {           
            $(".tab-pane.active .pagination-custom li a").each(function() {
                 var $this = $(this);    
                 var activepage =  $(".tab-pane.active").attr('id');
                 var _href = $this.attr("href"); 
                   $this.attr("href", _href + '#' + activepage);
              });

              var getPgText = +(20 * $(".tab-pane.active .pagination-custom li.active span").text());
           var getPgText2 = (Number(getPgText) - parseInt(20)) + 1;
           if(getPgText2 == 0){
             getPgText2 = 1;
           }
            
              var cnt = $('.tab-pane.active .blog_custom').text();
            $('.tab-pane.active span.btm-show-cnt').text(parseInt(getPgText2)+ "-"+parseInt(getPgText) + "  of " +cnt); 
           $('.tab-pane.active span.show-cnt').show();
            
          },2000);
        
        $(".blog-articles__article").hide();
        $(".loadMore").hide();
        setTimeout(function() {
          $(".tab-pane.active .blog-articles__article").slice(0, 20).show();
          setTimeout(function() {
              if ($('.tab-pane.active').find(".blog-articles__article:hidden").length == 0) {
                $(".tab-pane.active .loadMore").hide();
              }else{
                $(".tab-pane.active .loadMore").show();
              }
          }, 200);
      
    	}, 1000);
      });

      
         setTimeout(function() {           
             /*var activepage =  $(".tab-pane.active").attr('id');
             var currentUrl =  $(".pg-indx").attr('data-url');
            $('.pg-indx').attr('href',currentUrl+"#"+activepage); */


           $(".tab-pane.active .pagination-custom li a").each(function() {
               var $this = $(this);    
               var activepage =  $(".tab-pane.active").attr('id');
               var _href = $this.attr("href"); 
               $this.attr("href", _href + '#' + activepage);
          });


           var getPgText = +(20 * $(".tab-pane.active .pagination-custom li.active span").text());
           var getPgText2 = (Number(getPgText) - parseInt(20)) + 1;
           if(getPgText2 == 0){
             getPgText2 = 1;
           }

           
           var cnt = $('.tab-pane.active .blog_custom').text();
            $('.tab-pane.active span.btm-show-cnt').text(parseInt(getPgText2)+ "-"+parseInt(getPgText) + "  of " +cnt); 
           $('.tab-pane.active span.show-cnt').show();
           
         }, 2000);
   });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-announcement-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-announcement-slider')) {
    class CfAnnouncementSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.cf-announcement-slide'));
        if (this.slides.length < 2) return;

        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay =
          this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.userPaused = false;
        this.timer = null;

        this.prev = this.querySelector('.cf-announcement-prev');
        this.next = this.querySelector('.cf-announcement-next');
        this.toggle = this.querySelector('.cf-announcement-toggle');

        this.onPrev = () => {
          this.show(this.index - 1);
          this.start();
        };
        this.onNext = () => {
          this.show(this.index + 1);
          this.start();
        };
        this.onToggle = () => {
          this.userPaused = !this.userPaused;
          this.syncToggle();
          this.userPaused ? this.stop() : this.start();
        };
        this.onStop = () => this.stop();
        this.onStart = () => this.start();
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        this.onBlockSelect = (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.stop();
            this.show(i);
          }
        };

        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);
        this.toggle?.addEventListener('click', this.onToggle);

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.onStop);
          this.addEventListener('mouseleave', this.onStart);
        }
        this.addEventListener('focusin', this.onStop);
        this.addEventListener('focusout', this.onStart);
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor support
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onStart);

        this.show(this.index);
        this.start();
      }

      disconnectedCallback() {
        this.stop?.();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      show(nextIndex) {
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('inert', '');

        this.index = (nextIndex + this.slides.length) % this.slides.length;

        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].removeAttribute('inert');
      }

      start() {
        this.stop();
        if (!this.autoplay || this.userPaused) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.speed);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      syncToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.toggle.setAttribute(
          'aria-label',
          this.userPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause
        );
      }
    }

    customElements.define('cf-announcement-slider', CfAnnouncementSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



/*jQuery( document ).ready(function() {
      var maxHeight = 0;
    jQuery("li.slideshow-item .Product_slide_detail").each(function(){
       if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
    });    
    jQuery("li.slideshow-item .Product_slide_detail").height(maxHeight);
  
});*/

  
 
 jQuery( "#insta-feed h2" ).after( "<p>@charlesfish_jewellery</p>" );
  
   
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews_sec"] && !Shopify.designMode) return;
  try {
    
  const $slider = $('.review_main_slide');

  $slider.slick({
    infinite: false,
    centerMode: false,
    slidesToScroll: 1,
    speed: 400,
    dots: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
          slidesToScroll: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();
})();
